import { Col } from 'antd';
import { useTranslation } from 'react-i18next';
import * as permissionKind from '../../../../../shared/permissions';
import { useAccount } from '../../../../components/contexts/AccountContextManager';
import { useCompany } from '../../../../components/contexts/CompanyContextManager';
import FormFields from '../../../../themes/admin/Fields/FormFields';
import hasPermissions from '../../../../utilities/hasPermissions';
import useSystemOptions from '../../../../utilities/useSystemOptions';

const CompanySmsFields = () => {
    const { t } = useTranslation(['companyDetails']);
    const { smsProviderOptions } = useSystemOptions();
    const { permissions: accountPermissions } = useAccount();
    const company = useCompany(true);
    const hasPermission = company
        ? hasPermissions(company.permissions, [permissionKind.updateCompany]) &&
          hasPermissions(accountPermissions, [permissionKind.updateCompany])
        : hasPermissions(accountPermissions, [permissionKind.updateCompany]);

    return (
        <Col lg={8} xs={24}>
            <FormFields.SelectField
                {...t('companyDetails:fields.smsProvider', { returnObjects: true })}
                disabled={!hasPermission}
                name="smsSettings.provider"
                options={smsProviderOptions}
                required
                showSearch
            />
        </Col>
    );
};

export default CompanySmsFields;
